export function isMobile() {
	return window.matchMedia('(max-width: 992px)').matches;
}

export function setCookie(cName, cValue, expDays) {
	let date = new Date();
	date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
	const expires = "expires=" + date.toUTCString();
	document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

export function getCookie(cName) {
	const name = cName + "=";
	const cDecoded = decodeURIComponent(document.cookie); //to be careful
	const cArr = cDecoded .split('; ');
	let res;
	cArr.forEach(val => {
		if (val.indexOf(name) === 0) res = val.substring(name.length);
	})
	return res;
}

export function openModal(targetModal) {
	const html = document.querySelectorAll("html");
	const modal_redirect = document.querySelector(targetModal);
	html[0].classList.add("lock-scroll");
	modal_redirect.classList.toggle("active");
}

export function imageSrc(src) {
	const 	image = document.querySelector('.modal-redirect .image'),
			currentUrl = window.location.origin,
			themeLoc = '/wp-content/themes/vergo',
			imageSrc = currentUrl + themeLoc + src;
	image.src = imageSrc;
}

//
// Lazy load images
//
export function lazyLoadImages() {
	// Get all the images with the "data-src" attribute
	const images = document.querySelectorAll('img[data-src]');

	// Specify the distance below the viewport to load the images (in pixels)
	const distanceBelowViewport = window.innerHeight * 0.5;

	// Configure the Intersection Observer
	const config = {
		rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
		// threshold: 0 // Adjust the threshold as needed
	};

	// Create a new Intersection Observer
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const image = entry.target;

				// Set the "src" attribute with the value from "data-src"
				const src = image.getAttribute('data-src');
				if (src) {
					image.src = src;

					// Remove the "data-src" attribute
					image.removeAttribute('data-src');

					// Animate the opacity of the image
					image.style.transition = 'opacity 0.15s';
					image.style.opacity = '0';

					// Once the image is loaded, set opacity to 1
					image.onload = () => {
						image.style.opacity = '1';
						image.classList.add('lazy-loaded');
					};

					// Add a height attribute to the image
					const imageHeight = image.getAttribute('height');
					if (!imageHeight) {
						const computedStyle = window.getComputedStyle(image);
						image.style.height = computedStyle.getPropertyValue('height');
					}
				}

				// Stop observing the current image
				observer.unobserve(image);
			}
		});
	}, config);

	// Start observing each image
	images.forEach(image => {
		observer.observe(image);
	});
}


//
//
//
export function getUrlParameter(name) {
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString);
	return params.get(name);
}
